import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.b5m().v55() : headers;
  return DelegatedCall().z5n(_this__u8e3s4.w5l_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      static z5n(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.b5m().v55() : responseHeaders;
        var $this = this.a5o(client);
        $this.y5l_1 = new (DelegatedRequest())($this, originCall.b5o());
        $this.z5l_1 = new (DelegatedResponse())($this, originCall.b5m(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.g5o_1 = origin;
        this.h5o_1 = call;
      }
      i5o() {
        return this.h5o_1;
      }
      gw() {
        return this.g5o_1.gw();
      }
      j5o() {
        return this.g5o_1.j5o();
      }
      k5o() {
        return this.g5o_1.k5o();
      }
      c5o() {
        return this.g5o_1.c5o();
      }
      a2p() {
        return this.g5o_1.a2p();
      }
      v55() {
        return this.g5o_1.v55();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.v55() : headers;
        super();
        this.l5o_1 = call;
        this.m5o_1 = origin;
        this.n5o_1 = content;
        this.o5o_1 = headers;
        this.p5o_1 = this.m5o_1.gw();
      }
      i5o() {
        return this.l5o_1;
      }
      v55() {
        return this.o5o_1;
      }
      q5o() {
        return this.n5o_1(this.m5o_1);
      }
      gw() {
        return this.p5o_1;
      }
      r5o() {
        return this.m5o_1.r5o();
      }
      s5o() {
        return this.m5o_1.s5o();
      }
      t5o() {
        return this.m5o_1.t5o();
      }
      u5o() {
        return this.m5o_1.u5o();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
